export default __webpack_public_path__ + "static/media/doc-chat.6faf4e31.svg";